import { connect } from 'react-redux';

import {
  checkDailyQuizStatus,
  getQuestionsDailyQuiz,
  getResultsDailyQuiz,
  loadDailyQuiz,
  sendDailyQuizAnswer,
  setDailyQuiz,
  setDailyTimeOut,
  setSubmitDailyQuizSuccess,
  submitDailyQuiz,
  updateDailyQuiz,
} from '../actions/dailyQuizActions';
import { resetDailyQuizHistory } from '../actions/dashboardActions';
import {
  getDailyTimeOut,
  getLoadDailyQuizWaiting,
  getQuiz,
  getQuizRetake,
  getSubmitDailyQuizSuccess,
  getSubmitDailyQuizWaiting,
} from '../components/Daily20Quiz/daily20QuizSelectors';
import Daily20Quiz from '../components/Daily20Quiz/Daily20QuizView.jsx';
import { getUser } from '../components/User/userSelectors';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  quiz: getQuiz(state),
  quizRetake: getQuizRetake(state),
  user: getUser(state),
  loadDailyQuizWaiting: getLoadDailyQuizWaiting(state),
  submitDailyQuizWaiting: getSubmitDailyQuizWaiting(state),
  submitDailyQuizSuccess: getSubmitDailyQuizSuccess(state),
  dailyTimeOut: getDailyTimeOut(state),
});

const mapDispatchToProps = (dispatch) => ({
  getQuestionsDailyQuiz: () => dispatch(getQuestionsDailyQuiz()),
  sendDailyQuizAnswer: (answer) => dispatch(sendDailyQuizAnswer(answer)),
  getResultsDailyQuiz: () => dispatch(getResultsDailyQuiz()),
  verifyLoggedUser: () => verifyLoggedUser(),
  loadDailyQuiz: (id, isRetake) => dispatch(loadDailyQuiz(id, isRetake)),
  updateDailyQuiz: (dailyQuizId, dataResultsDetailed, isRetake) =>
    dispatch(updateDailyQuiz(dailyQuizId, dataResultsDetailed, isRetake)),
  submitDailyQuiz: (dailyQuizId, dataResultsDetailed, isRetake) =>
    dispatch(submitDailyQuiz(dailyQuizId, dataResultsDetailed, isRetake)),
  setSubmitDailyQuizSuccess: (value) =>
    dispatch(setSubmitDailyQuizSuccess(value)),
  setDailyQuiz: (quiz) => dispatch(setDailyQuiz(quiz)),
  checkDailyQuizStatus: () => dispatch(checkDailyQuizStatus()),
  setDailyTimeOut: (value) => dispatch(setDailyTimeOut(value)),
  resetDailyQuizHistory: () => dispatch(resetDailyQuizHistory()),
});

const Daily20QuizContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Daily20Quiz);

export default Daily20QuizContainer;
